import { Component } from "@angular/core";
import { PaginationService } from "../../services/pagination.service";

@Component({
  selector: "app-pagination",
  templateUrl: "./pagination.component.html",
  styleUrl: "./pagination.component.scss",
  standalone: false
})
export class PaginationComponent {
  constructor(public paginationService: PaginationService) {}
}
